<template>
  <div>
    <div class="content">
      <LoginLogo />

      <v-container>
        <!-- <v-form ref="form" :disabled="formSubmitted" v-on:submit.prevent="login" data-cy="login-form"> -->
          <v-row v-if="providerName">
            <v-btn @click="loginWithProvider" type="button" elevation="0" color="primary" class="mt-4" block>
              Login with {{ providerDisplayName }}
            </v-btn>
          </v-row>

          <v-row v-if="errorMessage" class="justify-center">
            <div  class="bg-error">
              {{ errorMessage }}
            </div>
          </v-row>
        <!-- </v-form> -->
      </v-container>
    </div>
  </div>
</template>

<script>
import { useAuthStore } from '@/stores/AuthStore'
import LoginLogo from './components/LoginLogo.vue'

export default {
  name: "AccountLoginProvider",
  components: {
    LoginLogo,
  },
  data() {
    return {
      providerName: '',
      providerDisplayName: '',

      errorMessage: '',
    };
  },
  mounted() {
    const providerParam = this.$route.params.provider || '';
    switch (providerParam.toLowerCase()) {
      case 'vnb': this.providerName = 'vnb'; this.providerDisplayName = 'VNB'; break;
      case 'unive': this.providerName = 'unive'; this.providerDisplayName = 'Univé'; break;

      default: this.errorMessage = 'Invalid login provider!';
    }
  },
  methods: {
    loginWithProvider() {
      const provider = {
        provider: {
          custom: this.providerName,
        }
      };

      const authStore = useAuthStore();
      authStore.signInWithProvider(provider);
    }
  }
}
</script>

<style>
</style>
